import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { apiService } from "./ReasuableFuncations/api";

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];
const AppLogout = ({ children }) => {
  const navigate = useNavigate();
  let timer;

  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      resetTimer();
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      logoutAction();
    },30 * 60 * 1000); // 30 minutes = 18000000ms 
  };
  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });
  }, []);

  const signOut = useCallback(async () => {
    try {
      await apiService.get("/api/logout");
    } catch (error) {
      console.error("Error during sign out:", error);
    } finally {
      localStorage.clear();
      Cookies.remove("accessToken");
      navigate("/");
    }
  }, [navigate]);

  const logoutAction = () => {
    signOut();
  };
  return children;
};
export default AppLogout;
